module.exports = __webpack_public_path__ + "img/5.8c8a426f.png";